<mat-card class="line-charts-container">
  <canvas
    baseChart
    height="180"
    [data]="lineChartData!"
    [options]="lineChartOptions"
    [type]="lineChartType"
  ></canvas>
</mat-card>
